import { AnimatePresence, motion } from "framer-motion";
import { WifiOff } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useT } from "@/lib/i18n";

export function OfflineBanner() {
  const { t } = useT();
  const [online, setOnline] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine));
  useEffect(() => {
    const on = () => {
      setOnline(true);
      toast.success(t("common.states.backOnline"));
    };
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, [t]);
  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          role="status"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          className="fixed inset-x-0 top-0 z-[90] flex items-center justify-center gap-2 bg-warn px-4 py-2 text-[13px] font-medium text-white"
        >
          <WifiOff className="size-4" />
          {t("common.states.offline")}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
